module.exports = __webpack_public_path__ + "img/金属材料学2_10.2bcf2f61.png";